// export const BaseUrl = "http://46.227.68.244:3050/api/v1";
// export const BaseUrlFiles = "http://46.227.68.244:3050";
export const BaseUrl = "https://tp.perlingo.ontco.com/api/v1";
export const BaseUrlFiles = "https://tp.perlingo.ontco.com";
